import React from "react";
import styled, { css, keyframes } from "styled-components";
import { FAB_DISAPPEAR_DURATION_IN_SECONDS } from "../burnout-animation-constants";
import {CyClass} from "../../../../../common/cy-classes";

export const BurnoutFab = ({zIndex, onClick, onMount, removeButton}: {zIndex: number; onClick(): void; onMount(): void; removeButton?: boolean;}) => {

    React.useEffect(() => {
        onMount();
    }, [onMount]);

    return (<BurnoutFabContainer zIndex={zIndex} onClick={onClick} removeButton={removeButton}>
        <BurnoutFabInner className={CyClass('cy-burnout-gift-button')}/>
    </BurnoutFabContainer>);
};

const disappearAnimation = keyframes`
    0% {
        transform: translateX(50%) scale(1.3);
        opacity: 1;
    }
    50% {
        transform: translateX(50%) scale(1.3);
        opacity: 1;
    }
    99% {
        transform: translateX(50%) scale(1.3);
        opacity: 0;
    }
    100% {
        transform: translateX(50%) scale(1.3);
        opacity: 0;
        display: none;
    }
`;

const pulseAnimation = keyframes`
    0% {
        transform: translateX(50%) scale(1);
    }
    50% {
        transform: translateX(50%) scale(1);
    }
    100% {
        transform: translateX(50%) scale(1.1);
    }
`;

const shadowAppear = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const BurnoutFabContainer = styled.div<{zIndex: number; removeButton?: boolean;}>`
    position: fixed;
    height: 60px;
    width: 60px;
    max-width: 60px;
    overflow: visible;
    top: 75px;
    right: 60px;
    @media ${({theme}) => theme.mediaQuery.sAndBelow } {
        right: 40px;
    }
    border-radius: 50%;
    cursor: pointer;
    /* A big z-index, to make sure it's above everything */
    z-index: ${({zIndex}) => zIndex};
    transform: translateX(50%);
    opacity: 0.9;
    /* box-shadow: 0px 0px 40px ${({theme}) => theme.colors.brandSecondary}, inset 0 0 40px ${({theme}) => theme.colors.brandSecondary}; */
    transition: transform 0.3s, opacity 0.3s;
    &:hover {
        transform: translateX(50%) scale(1.1);
        opacity: 1;
    }
    &:active {
        transform: translateX(50%) scale(1.3);
        opacity: 1;
    }
    ${({removeButton}) => removeButton ? css`
        animation: ${FAB_DISAPPEAR_DURATION_IN_SECONDS}s linear 0s 1 forwards running ${disappearAnimation};
    ` : css`
        animation: 1s linear 0s infinite alternate running ${pulseAnimation};
        &:hover {
            animation: 1s linear 0s infinite alternate paused ${pulseAnimation};
        }
    `}

    &::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 40%;
        height: 40%;
        top: 30%;
        left: 30%;
        background: transparent;
        border-radius: 50%;
        box-shadow: 0px 0px 40px 15px ${({theme}) => theme.colors.brandPrimary};
        transition: opacity 0.3s;
        opacity: 0;
        animation: 2s linear 0s 1 forwards running ${shadowAppear};
    }
`;

const BurnoutFabInner = styled.div`
    position: absolute;
    width: 100%;
    top: 50%;
    background-image: url(${({theme}) => theme.images.burnoutAnimation.lastFrame.toString()});
    background-position: 0 0;
    background-size: 100% 100%;
    /* Aspect ratio. 1000 / 600 = 1.(6) => In percentage 166.(6)% */
    height: 0;
    padding-top: calc(166.66667%);
    transform: translateY(-90%) scale(2);
    transition: transform 0.3s;
    @media ${({theme}) => theme.mediaQuery.lAndAbove } {
        transform: translate(-3%, -100%) scale(2.5);
    }
`;
